import React, { useState, useEffect } from "react";
import { results } from "./API";

const ProductCard = ({ product }) => {
  let image = product.images[3];
  const [cardTitle, setCardTitle] = useState(null);

  useEffect(() => {
    const resultsMatch = results.find((p) => p.productHandle == product.handle);
    if (resultsMatch) {
      setCardTitle(resultsMatch.cardTitle);
    }
  }, []);

  return (
    <div className="Card Card--product" data-layout="vertical media-content">
      <figure className="Card__media">
        <a href={`/products/${product.handle}`}>
          {image && (
            <ProductImage url={image} title={product.title}></ProductImage>
          )}
          <figcaption>
            <h4 className="Card__title">
              {cardTitle ? cardTitle : product.title}
            </h4>
          </figcaption>
        </a>
      </figure>
      <div className="Card__details">
        <h4 className="Card__title">
          <a href={`/products/${product.handle}`}>
            {cardTitle ? cardTitle : product.title}
          </a>
        </h4>
      </div>
    </div>
  );
};

const ProductImage = ({ url, title }) => {
  if (!url) {
    return null;
  }
  let firstSplit = url.split("?v=");
  let baseName = firstSplit[0].slice(0, -4);
  let extension = firstSplit[0].slice(-4);

  let sizes = [200, 400, 800];

  return (
    <img
      src={`${baseName}_200x${extension}`}
      srcSet={sizes.map((size) => `${baseName}_${size}x${extension} ${size}w,`)}
      sizes="auto"
      loading="lazy"
      alt={title}
    />
  );
};

export default ProductCard;
